import React from "react";

export const AuthPageLazy = React.lazy(() => import("./index"));
